// extracted by mini-css-extract-plugin
export default {"container":"Jn-z","brandName":"Kn-z","productName":"Ln-z","productNamePdpEnhancements":"Mn-z","breakLongProductName":"Nn-z"};